import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Keyboard } from "@phosphor-icons/react";

const SHORTCUTS = [
  { keys: ["N"], desc: "Yeni ders ekle (Panel / Takvim)" },
  { keys: ["?"], desc: "Bu yardım penceresini aç/kapat" },
  { keys: ["G", "D"], desc: "Panel'e git" },
  { keys: ["G", "T"], desc: "Takvim'e git" },
  { keys: ["G", "O"], desc: "Öğrenciler'e git" },
  { keys: ["G", "M"], desc: "Muhasebe'ye git" },
  { keys: ["G", "R"], desc: "Rapor'a git" },
  { keys: ["G", "A"], desc: "Ayarlar'a git" },
];

export default function ShortcutsDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <Keyboard size={22} weight="duotone" />
            Klavye Kısayolları
          </DialogTitle>
        </DialogHeader>
        <ul className="divide-y divide-border text-sm">
          {SHORTCUTS.map((s, i) => (
            <li key={i} className="flex items-center justify-between py-2.5">
              <span className="text-foreground">{s.desc}</span>
              <span className="flex items-center gap-1">
                {s.keys.map((k, j) => (
                  <React.Fragment key={j}>
                    {j > 0 && <span className="text-muted-foreground text-xs">sonra</span>}
                    <kbd className="inline-flex items-center justify-center min-w-[28px] h-7 px-2 rounded border border-border bg-muted font-mono text-xs font-semibold">{k}</kbd>
                  </React.Fragment>
                ))}
              </span>
            </li>
          ))}
        </ul>
        <p className="text-xs text-muted-foreground pt-2">
          Kısayollar yazı alanlarında çalışmaz. Herhangi bir sayfadan <kbd className="font-mono bg-muted px-1 py-0.5 rounded border border-border text-[10px]">?</kbd> tuşuna basarak buraya erişebilirsiniz.
        </p>
      </DialogContent>
    </Dialog>
  );
}
